export default "__VITE_ASSET__AVHFtS0q__"